import React from 'react'
import Card from '../../../../../reusableComponents/cards/Card1'

const AboutTheCourse = ({ courseData = {} }) => {
    return (
        <div>
            <Card
                showDescription={true}
                icon={null}
                description={courseData.description || 'No course description available.'}
                showLabels={false}
                showTitle={true}
                showIcon={false}
                title={courseData.courseName || 'Course Title'}
                className='w-full bg-white'
            />
        </div>
    )
}

export default AboutTheCourse